import { useReducer } from 'react';

export function useToggle(initialValue: boolean = false) {
  return useReducer(toggle, initialValue);
}

const toggle = (state: boolean) => !state;
